// FilterTag.js

import {
    defineComponent,
    computed,
    inject,
    ref,
    watch,
} from "/Scripts/vue.esm-browser.js";
import SareaBlock from "/Component/Shop/filter/SareaBlock.js";

const html = String.raw;

export default defineComponent({
    name: "FilterTag",
    props: {
        filters: {
            type: Object,
            required: true,
        },
        isSearch: {
            type: Boolean,
            default: false,
        },
        pagedData: {
            type: Array,
            default: []
        }
    },
    components: {
        SareaBlock
    },
    inject: ["filteredDataCount", "groupShowType"],
    emits: ["update:filters", "reset-filters"],
    setup(props, { emit }) {
        const sorts = inject("sorts");
        const nowPage = inject("nowPage");
        const groupShowType = inject("groupShowType");
        const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
        const sortDialogPopup = inject("sortDialogPopup", ref(false));
        const filterCount = inject("filterCount");
        const productStateDialogPopup = inject("productStateDialogPopup", ref(false));
        //const activeDayRanges = computed(() => {
        //    return Object.entries(props.filters.dayRanges)
        //        .filter(([_, range]) => range.active) // 僅存取值不需要索引時用_占位
        //        .map(([key, range]) => ({ key, range })); // 重組為物件陣列
        //});
        const activeDayRanges = computed(() => {
            return props.filters.dayRanges
                .filter(range => range.active) // 只保留 active 為 true 的
                .map(range => ({ range }));    // 若你還有需要加上其他資訊可擴充
        });

        const showPriceRange = computed(() => {
            const [min, max] = props.filters.priceRange;
            const [defaultMin, defaultMax] = props.filters.defaultPriceRange;
            return min !== defaultMin || max !== defaultMax;
        });

        const showDateRange = computed(() => {
            const [start, end] = props.filters.dateRange;
            const [defaultStart, defaultEnd] = props.filters.defaultDateRange;
            return start !== defaultStart || end !== defaultEnd;
        });

        const formatPriceRange = computed(() => {
            const [min, max] = props.filters.priceRange;
            return `${min.toLocaleString()}~${max.toLocaleString()}元`;
        });

        const formatDateRange = computed(() => {
            const [start, end] = props.filters.dateRange;
            return `${start}~${end}`;
        });

        const removePriceRange = () => {
            emit("update:filters", {
                ...props.filters,
                priceRange: [...props.filters.defaultPriceRange],
            });
        };

        const removeDateRange = () => {
            emit("update:filters", {
                ...props.filters,
                dateRange: [...props.filters.defaultDateRange],
            });
        };

        const activeGroupStatus = computed(() => {
            return Object.entries(props.filters.groupStatus)
                .filter(([_, value]) => value) // 僅存取值不需要索引時用_占位
                .map(([key, value]) => {
                    switch (key) {
                        case "guaranteed":
                            return "保證出發";
                        case "forming":
                            return "即將成團";
                        default:
                            return;
                    }
                }); // 重組為物件陣列
        });
        const weekdays = [
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六",
        ];
        const activeWeekdays = computed(() => {
            return Array.from(props.filters.selectedWeekdays).map(
                (index) => weekdays[index]
            );
        });

        const activeAirlines = computed(() => {
            return Array.from(props.filters.selectedAirlines).map(
                (index) => transService.airlineMap[index]
            );
        });
        const formatDayRange = (range) => {
            if (range.rangeStart === 0) {
                return `${range.rangeEnd}天以下`;
            }
            if (range.rangeEnd === 0) {
                return `${range.rangeStart}天以上`;
            }
            return `${range.rangeStart}~${range.rangeEnd}天`;
        };
        const totalFilterNum = computed(() => {
            let count = 0;
            if (showPriceRange.value) {
                count++;
            }
            if (showDateRange.value) {
                count++;
            }
            count += activeWeekdays.value.length;
            count += activeGroupStatus.value.length;
            count += activeAirlines.value.length;
            count += activeDayRanges.value.length;
            count += props.filters.featureTags.size;


            return count;
        });
        const sortDate = () => {
            if (sorts.value.date.active) {
                sorts.value.date.sort =
                    sorts.value.date.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.date.active = true;
            sorts.value.price.active = false;
            sorts.value.day.active = false;
        };
        const sortPrice = () => {
            if (sorts.value.price.active) {
                sorts.value.price.sort =
                    sorts.value.price.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.price.active = true;
            sorts.value.date.active = false;
            sorts.value.day.active = false;
        };
        const sortDay = () => {
            if (sorts.value.day.active) {
                sorts.value.day.sort =
                    sorts.value.day.sort === "asc" ? "desc" : "asc";
            }
            sorts.value.day.active = true;
            sorts.value.date.active = false;
            sorts.value.price.active = false;
        };

        const removeWeekday = (weekday) => {
            const index = weekdays.indexOf(weekday);
            const newWeekdays = new Set(props.filters.selectedWeekdays);
            newWeekdays.delete(index);
            emit("update:filters", {
                ...props.filters,
                selectedWeekdays: newWeekdays,
            });
        };

        const removeGroupStatus = (status) => {
            const key = status === "保證出發" ? "guaranteed" : "forming";
            emit("update:filters", {
                ...props.filters,
                groupStatus: {
                    ...props.filters.groupStatus,
                    [key]: false,
                },
            });
        };

        const removeAirline = (airline) => {
            // 找到要刪除的航空公司的索引
            const indexToRemove = Array.from(
                props.filters.selectedAirlines
            ).find((index) => transService.airlineMap[index] === airline);

            if (indexToRemove !== undefined) {
                const newAirlines = new Set(props.filters.selectedAirlines);
                newAirlines.delete(indexToRemove);
                emit("update:filters", {
                    ...props.filters,
                    selectedAirlines: newAirlines,
                });
            }
        };

        const removeFeatureTag = (tag) => {
            const newTags = new Set(
                [...props.filters.featureTags].filter((t) => t !== tag)
            );
            emit("update:filters", {
                ...props.filters,
                featureTags: newTags,
            });
        };

        const removeDayRange = (targetRange) => {
            const updatedDayRanges = props.filters.dayRanges.map(range => {
                if (
                    range.rangeStart === targetRange.rangeStart &&
                    range.rangeEnd === targetRange.rangeEnd
                ) {
                    return { ...range, active: false };
                }
                return range;
            });

            emit("update:filters", {
                ...props.filters,
                dayRanges: updatedDayRanges,
            });
        };
        const resetFilters = () => {
            emit("reset-filters");
        };

        const toggleGroupShowType = () => {
            nowPage.value = 1;//回到第一頁
            groupShowType.value =
                groupShowType.value === "uni" ? "horizontal" : "uni";
        };
        watch(
            () => totalFilterNum.value,
            (newFilters) => {
                filterCount.value = newFilters;
            },
            { deep: true }
        );
        

        return {
            activeDayRanges,
            formatDayRange,
            activeWeekdays,
            activeAirlines,
            activeGroupStatus,
            sorts,
            sortDate,
            sortPrice,
            sortDay,
            removeWeekday,
            removeGroupStatus,
            removeAirline,
            removeFeatureTag,
            removeDayRange,
            resetFilters,
            showPriceRange,
            formatPriceRange,
            removePriceRange,
            showDateRange,
            formatDateRange,
            removeDateRange,
            toggleGroupShowType,
            mobileFilterPopup,
            sortDialogPopup,
            productStateDialogPopup,
            filterCount,
            totalFilterNum
        };
    },
    mounted() {
        let filter_tag_list = document.querySelector(
            ".product_wrap .filter_tag_list_box .filter_tag_list"
        );
        if (filter_tag_list) {
            function filterTagDisplay() {
                const labels = Array.from(filter_tag_list.children).filter(
                    (label) => label.classList.contains("filter_tag")
                );
                const filter_tag_list_lineNumber = 2; //行數
                const filter_tag_list_gap = 8; //按鈕之間的間隔px

                const wrapWidth =
                    document.querySelector(".artical_wrap .filter_tag_list")
                        .offsetWidth * filter_tag_list_lineNumber;
                const availableWidth =
                    wrapWidth -
                    filter_tag_list.querySelector(".more_btn").offsetWidth -
                    filter_tag_list.querySelector(".tagDelete_btn")
                        .offsetWidth -
                    filter_tag_list_gap;
                let labelTotalWidth = 0;
                let hasHiddenItems = false;
                labels.forEach((label) => {
                    label.style.display = "none";
                });

                // 取得第一行的最右邊filter_tag與filter_tag_list右邊的空隙
                function getRightGap() {
                    const labels = Array.from(filter_tag_list.children).filter(
                        (label) => label.classList.contains("filter_tag")
                    ); // 取得所有 li

                    // 取得第一個 label 的 top，作為第一行的基準
                    const firstRowTop = labels[0].offsetTop;

                    // 篩選出所有第一行的 label
                    const firstRowItems = labels.filter(
                        (label) => label.offsetTop === firstRowTop
                    );

                    // 找出第一行最右邊的 label（計算 offsetLeft + offsetWidth）
                    let rightMostLi = firstRowItems.reduce(
                        (rightMost, label) => {
                            return label.offsetLeft + label.offsetWidth >
                                rightMost.offsetLeft + rightMost.offsetWidth
                                ? label
                                : rightMost;
                        },
                        firstRowItems[0]
                    );

                    // 計算 List 右邊與最右邊 label 之間的距離
                    const ListRightEdge =
                        filter_tag_list.offsetLeft +
                        filter_tag_list.offsetWidth;
                    const labelRightEdge =
                        rightMostLi.offsetLeft + rightMostLi.offsetWidth;
                    return ListRightEdge - labelRightEdge;
                }

                for (const label of labels) {
                    label.style.display = "";
                    labelTotalWidth += label.offsetWidth + filter_tag_list_gap;
                    if (labelTotalWidth + getRightGap() > availableWidth) {
                        label.style.display = "none";
                        hasHiddenItems = true;
                    }
                }
                filter_tag_list.querySelector(".more_btn").style.display =
                    hasHiddenItems ? "block" : "none";
            }

            if (!filter_tag_list.classList.contains("close")) {
                filter_tag_list.classList.add("close");
            }

            function filterTagDisplayCheck() {
                if (filter_tag_list.classList.contains("close")) {
                    filterTagDisplay();
                } else {
                    const filter_tags =
                        filter_tag_list.querySelectorAll(".filter_tag");
                    filter_tags.forEach((filter_tag) => {
                        filter_tag.style.display = "";
                    });
                }
            }

            document.addEventListener(
                "DOMContentLoaded",
                filterTagDisplayCheck()
            );

            const moreBtn = document.querySelector(".more_btn");
            moreBtn.addEventListener("click", function () {
                filter_tag_list.classList.toggle("close");
                filterTagDisplayCheck();
                moreBtn.textContent =
                    moreBtn.textContent === "更多..." ? "收合" : "更多...";
            });
            document
                .querySelector(".filter_toggle_btn")
                .addEventListener("click", filterTagDisplayCheck);
            const filterTagObserver = new MutationObserver(() => {
                filterTagDisplayCheck();
            });

            filterTagObserver.observe(filter_tag_list, {
                childList: true,
                subtree: true,
            });

            const filterTagsObserver = new ResizeObserver((entries) => {
                requestAnimationFrame(() => {
                    filterTagDisplayCheck();
                });
            });

            filterTagsObserver.observe(filter_tag_list);

            // 監聽螢幕寬度變化
            window.addEventListener("resize", filterTagDisplayCheck);
        }
    },

    template: html`
        <div class="filterTag_block">
            <div v-if="isSearch" class="title_h1">搜尋結果</div>
            <div class="tag_number_box">
                共
                <span class="tag_number">{{ filteredDataCount }}</span>
                款
            </div>
            <div class="filterTag_block_list">
                <div class="filter_tag_list_box">
                    <div class="filter_tag_list close">
                        <label class="filter_tag" v-if="showPriceRange">
                            <span>{{ formatPriceRange }}</span>
                            <button class="tag_close" @click="removePriceRange">
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label class="filter_tag" v-if="showDateRange">
                            <span>{{ formatDateRange }}</span>
                            <button class="tag_close" @click="removeDateRange">
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label
                            class="filter_tag"
                            v-for="weekday in activeWeekdays"
                            :key="weekday"
                        >
                            <span>{{ weekday}}</span>
                            <button
                                class="tag_close"
                                @click="removeWeekday(weekday)"
                            >
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label
                            class="filter_tag"
                            v-for="status in activeGroupStatus"
                            :key="status"
                        >
                            <span>{{ status}}</span>
                            <button
                                class="tag_close"
                                @click="removeGroupStatus(status)"
                            >
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label
                            class="filter_tag"
                            v-for="airline in activeAirlines"
                            :key="airline"
                        >
                            <span>{{ airline}}</span>
                            <button
                                class="tag_close"
                                @click="removeAirline(airline)"
                            >
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label
                            class="filter_tag"
                            v-for="tag in filters.featureTags"
                            :key="tag"
                        >
                            <span>{{ tag}}</span>
                            <button
                                class="tag_close"
                                @click="removeFeatureTag(tag)"
                            >
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <label
                            class="filter_tag"
                            v-for="(item, index) in activeDayRanges"
                            :key="index"
                        >
                            <span>{{ formatDayRange(item.range) }}</span>
                            <button
                                class="tag_close"
                                @click="removeDayRange(item.range)"
                            >
                                <svg>
                                    <use xlink:href="#Com_icon_close"></use>
                                </svg>
                            </button>
                        </label>
                        <button class="more_btn">更多...</button>
                        <button class="tagDelete_btn" @click="resetFilters">
                            清除全部
                        </button>
                    </div>
                </div>
                
                <div class="sort_box-m" v-if="isSearch">
                    <div class="sort_btn_list">
                        <button class="sort_btn-change" @click="productStateDialogPopup=true">
                            <div class="btn_img">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="13"
                                    viewBox="0 0 14 13"
                                    fill="none"
                                >
                                    <path
                                        d="M1.73483 2.73483C1.58839 2.88128 1.58839 3.11872 1.73483 3.26516L4.12132 5.65165C4.26777 5.7981 4.5052 5.7981 4.65165 5.65165C4.7981 5.5052 4.7981 5.26777 4.65165 5.12132L2.53033 3L4.65165 0.878679C4.7981 0.732233 4.7981 0.494796 4.65165 0.348349C4.5052 0.201903 4.26777 0.201903 4.12132 0.348349L1.73483 2.73483ZM14 2.625L2 2.625L2 3.375L14 3.375L14 2.625Z"
                                        fill="#736357"
                                    ></path>
                                    <path
                                        d="M12.2652 10.2652C12.4116 10.1187 12.4116 9.88128 12.2652 9.73484L9.87868 7.34835C9.73223 7.2019 9.4948 7.2019 9.34835 7.34835C9.2019 7.4948 9.2019 7.73223 9.34835 7.87868L11.4697 10L9.34835 12.1213C9.2019 12.2678 9.2019 12.5052 9.34835 12.6517C9.4948 12.7981 9.73223 12.7981 9.87868 12.6517L12.2652 10.2652ZM-1.63918e-08 10.375L12 10.375L12 9.625L1.63918e-08 9.625L-1.63918e-08 10.375Z"
                                        fill="#736357"
                                    ></path>
                                </svg>
                            </div>
                            切換
                        </button>
                        <button class="sort_btn-sort" @click="sortDialogPopup=true">
                            <div class="btn_img">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="21"
                                    viewBox="0 0 18 21"
                                    fill="none"
                                >
                                    <path
                                        d="M8.67852 20.9526C7.2964 20.5182 6.05253 19.7755 4.74091 19.1847C3.63641 18.6874 2.55103 18.1485 1.45582 17.6304C0.432753 17.1462 -0.156933 16.0652 0.0365324 15.0252C0.115777 14.5994 0.486858 14.3054 0.896742 14.3437C1.34543 14.3858 1.68153 14.7333 1.64656 15.1793C1.60611 15.6968 1.82581 16.0018 2.28598 16.2171C4.39332 17.2047 6.49357 18.2086 8.59436 19.2098C8.86543 19.3388 9.12666 19.3475 9.39883 19.2186C11.5499 18.196 13.7021 17.1757 15.8537 16.1532C16.2477 15.9663 16.3942 15.6493 16.3636 15.2203C16.3302 14.7541 16.6379 14.4011 17.0943 14.3464C17.5189 14.2961 17.9315 14.5934 17.9676 15.0465C17.9955 15.3924 17.9785 15.7597 17.8911 16.0936C17.7009 16.821 17.2134 17.32 16.5374 17.6402C15.4667 18.1469 14.3978 18.6557 13.3282 19.1634C12.2647 19.6683 11.2034 20.1782 10.1355 20.6734C9.87976 20.792 9.60158 20.8614 9.33325 20.9532H8.67852V20.9526Z"
                                        fill="#A99F96"
                                    ></path>
                                    <path
                                        d="M0.00586312 5.41661C0.0479445 4.56241 0.492805 3.79948 1.40439 3.36063C3.57459 2.31516 5.75353 1.28771 7.92974 0.256447C8.62927 -0.0752861 9.34192 -0.0900419 10.042 0.240598C12.233 1.2735 14.4223 2.31024 16.6051 3.36009C17.4686 3.77544 17.9468 4.48809 17.9954 5.44339C18.0435 6.38831 17.6527 7.14523 16.8461 7.64802C16.4728 7.88083 16.0575 8.04643 15.658 8.23661C13.8146 9.11376 11.9696 9.98709 10.1273 10.8653C9.37745 11.2228 8.63364 11.2228 7.88383 10.8653C5.73385 9.84172 3.58114 8.82247 1.43062 7.7994C0.541445 7.37586 0.00422358 6.52986 0.00586312 5.41661ZM9.00855 1.61617C8.86427 1.66426 8.71726 1.69705 8.58501 1.7599C6.45689 2.76712 4.33096 3.7809 2.20229 4.78703C1.86346 4.94716 1.64704 5.18434 1.64595 5.56799C1.64485 5.9511 1.85799 6.19266 2.19683 6.35279C4.30691 7.35072 6.41645 8.34974 8.52161 9.35915C8.85006 9.51654 9.14737 9.52474 9.47582 9.36789C11.5941 8.3552 13.7162 7.35017 15.8372 6.34404C16.1684 6.18719 16.3679 5.93798 16.3651 5.56417C16.3624 5.19965 16.1662 4.95481 15.8427 4.80124C13.7025 3.78637 11.5635 2.7704 9.42281 1.75771C9.29602 1.6976 9.15556 1.6659 9.00855 1.61617Z"
                                        fill="#A99F96"
                                    ></path>
                                    <path
                                        d="M8.99783 16.0447C8.60981 16.042 8.24419 15.9464 7.89497 15.7802C5.73789 14.7539 3.57917 13.7314 1.42263 12.7028C0.420878 12.2252 -0.154052 11.1458 0.0361339 10.1189C0.116471 9.6839 0.496843 9.38878 0.914378 9.43687C1.36361 9.48879 1.68223 9.83637 1.64725 10.2878C1.6079 10.7873 1.82159 11.089 2.26536 11.2977C4.37817 12.2902 6.48497 13.2952 8.59232 14.2997C8.87104 14.4325 9.1361 14.4347 9.41537 14.3019C11.5599 13.281 13.7066 12.2645 15.8522 11.2453C16.2457 11.0584 16.3943 10.743 16.3637 10.3135C16.3298 9.83965 16.649 9.4795 17.1124 9.43523C17.5294 9.39534 17.9322 9.69155 17.9677 10.1353C17.9951 10.4813 17.9792 10.8485 17.8923 11.1824C17.7054 11.9022 17.2261 12.4033 16.5583 12.7214C15.2308 13.3532 13.9022 13.9828 12.5748 14.6129C11.7512 15.0042 10.927 15.3949 10.1034 15.7868C9.75366 15.9529 9.38695 16.0431 8.99893 16.0447H8.99783Z"
                                        fill="#A99F96"
                                    ></path>
                                </svg>
                            </div>
                            排序
                        </button>
                        <button class="sort_btn-filter" v-on:click="mobileFilterPopup=true">
                            <div class="filter_number">{{ filterCount > 9 ? '9+' : filterCount }}</div>
                            <div class="btn_img">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="19"
                                    viewBox="0 0 19 19"
                                    fill="none"
                                >
                                    <path
                                        d="M18.1419 15.5034H14.9687C14.7921 14.0894 13.5835 12.9922 12.1226 12.9922C10.6617 12.9922 9.45305 14.0894 9.27641 15.5034H0.858059C0.659933 15.5034 0.5 15.6633 0.5 15.8614C0.5 16.0596 0.659933 16.2195 0.858059 16.2195H9.27641C9.45305 17.6334 10.6617 18.7307 12.1226 18.7307C13.5835 18.7307 14.7921 17.6334 14.9687 16.2195H18.1419C18.3401 16.2195 18.5 16.0596 18.5 15.8614C18.5 15.6633 18.3401 15.5034 18.1419 15.5034ZM12.1226 18.0146C11.0572 18.0146 10.1708 17.2372 9.99969 16.2195C9.9798 16.1033 9.96945 15.9832 9.96945 15.8614C9.96945 15.7397 9.9798 15.6195 9.99969 15.5034C10.1708 14.4857 11.0572 13.7083 12.1226 13.7083C13.188 13.7083 14.0744 14.4857 14.2455 15.5034C14.2654 15.6195 14.2757 15.7397 14.2757 15.8614C14.2757 15.9832 14.2654 16.1033 14.2455 16.2195C14.0744 17.2372 13.188 18.0146 12.1226 18.0146Z"
                                        fill="#736357"
                                    ></path>
                                    <path
                                        d="M0.858059 3.2273H9.27641C9.45305 4.64123 10.6617 5.73848 12.1226 5.73848C13.5835 5.73848 14.7921 4.64123 14.9687 3.2273H18.1419C18.3401 3.2273 18.5 3.06737 18.5 2.86924C18.5 2.67112 18.3401 2.51118 18.1419 2.51118H14.9687C14.7921 1.09725 13.5835 0 12.1226 0C10.6617 0 9.45305 1.09725 9.27641 2.51118H0.858059C0.659933 2.51118 0.5 2.67112 0.5 2.86924C0.5 3.06737 0.659933 3.2273 0.858059 3.2273ZM12.1226 0.716117C13.188 0.716117 14.0744 1.4935 14.2455 2.51118C14.2654 2.62735 14.2757 2.7475 14.2757 2.86924C14.2757 2.99098 14.2654 3.11113 14.2455 3.2273C14.0744 4.24498 13.188 5.02237 12.1226 5.02237C11.0572 5.02237 10.1708 4.24498 9.99969 3.2273C9.9798 3.11113 9.96945 2.99098 9.96945 2.86924C9.96945 2.7475 9.9798 2.62735 9.99969 2.51118C10.1708 1.4935 11.0572 0.716117 12.1226 0.716117Z"
                                        fill="#736357"
                                    ></path>
                                    <path
                                        d="M18.1419 9.03511H7.86089C7.68424 7.62118 6.4756 6.52393 5.01472 6.52393C3.55384 6.52393 2.34519 7.62118 2.16855 9.03511H0.858058C0.659933 9.03511 0.5 9.19504 0.5 9.39317C0.5 9.59129 0.659933 9.75123 0.858058 9.75123H2.16855C2.34519 11.1652 3.55384 12.2624 5.01472 12.2624C6.4756 12.2624 7.68424 11.1652 7.86089 9.75123H18.1411C18.3393 9.75123 18.4992 9.59129 18.4992 9.39317C18.4992 9.19504 18.3393 9.03511 18.1411 9.03511H18.1419ZM5.01472 11.5463C3.9493 11.5463 3.0629 10.7689 2.89183 9.75123C2.87194 9.63506 2.86159 9.51491 2.86159 9.39317C2.86159 9.27143 2.87194 9.15128 2.89183 9.03511C3.0629 8.01743 3.9493 7.24004 5.01472 7.24004C6.08014 7.24004 6.96654 8.01743 7.13761 9.03511C7.1575 9.15128 7.16784 9.27143 7.16784 9.39317C7.16784 9.51491 7.1575 9.63506 7.13761 9.75123C6.96654 10.7689 6.08014 11.5463 5.01472 11.5463Z"
                                        fill="#736357"
                                    ></path>
                                </svg>
                            </div>
                            篩選
                        </button>
                    </div>
                </div>
                <div class="sort_box">
                    <div class="sort_btn_list">
                        <button :class="['sort_btn sort_btn-SEARA', groupShowType === 'region' ? 'active' : '']" v-if="isSearch" @click="groupShowType= (groupShowType=='region' ? 'horizontal' : 'region')">
                            依地區排序
                        </button>
                        <div class="line" v-if="isSearch"></div>
                        <button
                            class="sort_btn"
                            @click="sortDate"
                            :class="{'active':sorts.date.active}"
                        >
                            {{sorts.date.sort==='asc' ? '日期近到遠' : '日期遠到近'}}
                            <div class="">
                                <i
                                    class="fa-solid"
                                    :class="{'fa-arrow-up-wide-short':sorts.date.sort === 'asc','fa-arrow-down-wide-short':sorts.date.sort === 'desc'}"
                                ></i>
                            </div>
                        </button>
                        <div class="line"></div>
                        <button
                            class="sort_btn"
                            @click="sortPrice"
                            :class="{'active':sorts.price.active}"
                        >
                            {{sorts.price.sort === 'asc' ? '價格低到高' : '價格高到低'}}
                            <div class="">
                                <i
                                    class="fa-solid"
                                    :class="{'fa-arrow-up-wide-short':sorts.price.sort === 'asc','fa-arrow-down-wide-short':sorts.price.sort === 'desc'}"
                                ></i>
                            </div>
                        </button>
                        <div class="line"></div>
                        <button
                            class="sort_btn"
                            @click="sortDay"
                            :class="{'active':sorts.day.active}"
                        >
                            {{sorts.day.sort === 'asc' ? '天數低到高' : '天數高到低'}}
                            <div class="">
                                <i
                                    class="fa-solid"
                                    :class="{'fa-arrow-up-wide-short':sorts.day.sort === 'asc','fa-arrow-down-wide-short':sorts.day.sort === 'desc'}"
                                ></i>
                            </div>
                        </button>
                    </div>
                    <button
                        :class="['sort_change_btn', groupShowType === 'uni' ? 'active' : '']"
                        v-if="isSearch"
                        @click="toggleGroupShowType"
                    >
                        <svg
                            width="14"
                            height="13"
                            viewBox="0 0 14 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.734835 2.73483C0.588388 2.88128 0.588388 3.11872 0.734835 3.26516L3.12132 5.65165C3.26777 5.7981 3.5052 5.7981 3.65165 5.65165C3.7981 5.5052 3.7981 5.26777 3.65165 5.12132L1.53033 3L3.65165 0.878679C3.7981 0.732233 3.7981 0.494796 3.65165 0.348349C3.5052 0.201903 3.26777 0.201903 3.12132 0.348349L0.734835 2.73483ZM13 2.625L1 2.625L1 3.375L13 3.375L13 2.625Z"
                                fill="white"
                            ></path>
                            <path
                                d="M13.2652 10.2652C13.4116 10.1187 13.4116 9.88128 13.2652 9.73484L10.8787 7.34835C10.7322 7.2019 10.4948 7.2019 10.3483 7.34835C10.2019 7.4948 10.2019 7.73223 10.3483 7.87868L12.4697 10L10.3483 12.1213C10.2019 12.2678 10.2019 12.5052 10.3483 12.6517C10.4948 12.7981 10.7322 12.7981 10.8787 12.6517L13.2652 10.2652ZM1 10.375L13 10.375L13 9.625L1 9.625L1 10.375Z"
                                fill="white"
                            ></path>
                        </svg>
                        <span>{{groupShowType==="horizontal" ? "產品" : "出發日"}}</span>
                    </button>
                </div>
            </div>
            <sarea-block :pagedData="pagedData" v-if="groupShowType==='region'"></sarea-block>
        </div>
    `,
    methods: {},
});
